export default __webpack_public_path__ + "static/media/course3.d0e7201e.webp";